import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default function CustomFieldIcon(props: any) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 17.01 17.01"
      style={{ width: `16px`, height: `16px`, color: RoutalPalette.primary40, ...props.style }}
    >
      <g id="uuid-06db2cdd-5445-452b-84c4-36bd94cb5e31">
        <path d="M16.18,2.08H6.63c-.23-1.1-1.21-1.93-2.38-1.93s-2.15.83-2.38,1.93H.83c-.27,0-.49.22-.49.49s.22.49.49.49h1.05c.23,1.1,1.21,1.93,2.38,1.93s2.15-.83,2.38-1.93h9.54c.27,0,.49-.22.49-.49s-.22-.49-.49-.49ZM4.26,4.01c-.79,0-1.44-.65-1.44-1.44s.65-1.44,1.44-1.44,1.44.65,1.44,1.44-.65,1.44-1.44,1.44Z" />
        <path d="M16.18,13.94H6.63c-.23-1.1-1.21-1.93-2.38-1.93s-2.15.83-2.38,1.93H.83c-.27,0-.49.22-.49.49s.22.49.49.49h1.05c.23,1.1,1.21,1.93,2.38,1.93s2.15-.83,2.38-1.93h9.54c.27,0,.49-.22.49-.49s-.22-.49-.49-.49ZM4.26,15.87c-.79,0-1.44-.65-1.44-1.44s.65-1.44,1.44-1.44,1.44.65,1.44,1.44-.65,1.44-1.44,1.44Z" />
        <path d="M.34,8.5c0,.27.22.49.49.49h9.54c.23,1.1,1.21,1.93,2.38,1.93s2.15-.83,2.38-1.93h1.05c.27,0,.49-.22.49-.49,0-.27-.22-.49-.49-.49h-1.05c-.23-1.1-1.21-1.93-2.38-1.93s-2.15.83-2.38,1.93H.83c-.27,0-.49.22-.49.49ZM11.31,8.5c0-.79.65-1.44,1.44-1.44s1.44.65,1.44,1.44-.65,1.44-1.44,1.44-1.44-.65-1.44-1.44Z" />
      </g>
    </SvgIcon>
  );
}
